export default ({ next, store }) => {
  const user = store.getters['User/userState']
  if (user.is_agent_application) {
    location.href = '/'
    return false
  }
  next()
}
